"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _prepareChildKeys2 = _interopRequireDefault(require("./prepareChildKeys"));

var _updateChildKeys = _interopRequireDefault(require("./updateChildKeys"));

var _push = _interopRequireDefault(require("unmutable/lib/push"));

var _default = function _default() {
  for (var _len = arguments.length, newValues = new Array(_len), _key = 0; _key < _len; _key++) {
    newValues[_key] = arguments[_key];
  }

  return function (parcelData) {
    var _prepareChildKeys = (0, _prepareChildKeys2["default"])()(parcelData),
        value = _prepareChildKeys.value,
        child = _prepareChildKeys.child,
        rest = (0, _objectWithoutProperties2["default"])(_prepareChildKeys, ["value", "child"]);

    var emptyChildren = newValues.map(function () {
      return {};
    });
    return (0, _updateChildKeys["default"])()((0, _objectSpread2["default"])({}, rest, {
      value: _push["default"].apply(void 0, newValues)(value),
      child: _push["default"].apply(void 0, (0, _toConsumableArray2["default"])(emptyChildren))(child)
    }));
  };
};

exports["default"] = _default;